<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <h3>
        {{ `${repair.code}` }} -
        {{ $t("COMMON.LOGS") }}
      </h3>
    </div>
    <log-list-table :filterSubject="repair" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "repair-view-logs",

  components: { LogListTable },

  props: ["repair"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
